import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import { useState } from 'react';

import { ListItemButtonChildren } from './dependencies';

interface CollapsableItemProps {
  title: string;
  icon: React.ReactNode;
  children: React.ReactNode;
}

export const CollapsableItem = ({ title, icon, children }: CollapsableItemProps) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const handleClick = () => {
    setOpen(!open);
  };
  return (
    <>
      <ListItemButtonChildren onClick={handleClick}>
        {icon}
        <ListItemText
          primary={title}
          sx={{
            span: {
              fontWeight: theme.typography.fontWeightBold,
              fontSize: '1rem',
              color: theme.palette.grey[500],
            },
          }}
        />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItemButtonChildren>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </>
  );
};
